var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeryNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_43660)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.534 17.5473C42.4867 24.1044 31.8777 27.4531 21.148 27.5132C10.2773 27.5734 -0.754401 24.2848 0.956721 17.5473C6.69401 -5.11162 33.3875 -6.3749 40.534 17.5473Z",
    fill: "url(#paint0_radial_38_43660)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9333 20.1476C28.0288 20.1476 28.9084 19.3343 28.9084 18.3384C28.9084 17.3426 28.0122 16.5293 26.9333 16.5293C25.8379 16.5293 24.9582 17.3426 24.9582 18.3384C24.9416 19.3509 25.8379 20.1476 26.9333 20.1476Z",
    fill: "#B066F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2659 19.9835C28.3613 19.9835 29.241 19.1702 29.241 18.1744C29.241 17.1785 28.3447 16.3652 27.2659 16.3652C26.1704 16.3652 25.2908 17.1785 25.2908 18.1744C25.2742 19.1868 26.1704 19.9835 27.2659 19.9835Z",
    fill: "#14110E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5308 11.1199C25.2237 12.3482 27.9291 12.0992 29.1573 10.373",
    stroke: "#B066F4",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9664 11.1199C17.2735 12.3482 14.5681 12.0992 13.3398 10.373",
    stroke: "#B066F4",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5308 10.7371C25.2237 11.9653 27.9291 11.7164 29.1573 9.99023",
    stroke: "#14110E",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9664 10.7371C17.2735 11.9653 14.5681 11.7164 13.3398 9.99023",
    stroke: "#14110E",
    strokeWidth: 0.995867,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.4245 16.8429C23.4245 18.8677 21.7813 20.5275 19.7564 20.5275C17.7315 20.5275 16.0884 18.8843 16.0884 16.8429C16.0884 14.818 17.7315 13.1582 19.7564 13.1582C21.7813 13.1582 23.4245 14.8014 23.4245 16.8429Z",
    fill: "url(#paint1_radial_38_43660)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.047 16.5108C34.047 18.5357 32.4039 20.1955 30.379 20.1955C28.3541 20.1955 26.7109 18.5523 26.7109 16.5108C26.7109 14.4859 28.3541 12.8262 30.379 12.8262C32.4039 12.8262 34.047 14.4693 34.047 16.5108Z",
    fill: "url(#paint2_radial_38_43660)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_38_43660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7741 13.7951) rotate(90) scale(13.7189 19.9938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.546885,
    stopColor: "#E9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A951FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_38_43660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.7593 16.835) scale(3.6677 3.6809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_38_43660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.3819 16.503) scale(3.6677 3.6809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C0EE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1788,
    stopColor: "#7C0EE1",
    stopOpacity: 0.8196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#7C0EE1",
    stopOpacity: 0.579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6896,
    stopColor: "#7C0EE1",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9914,
    stopColor: "#7C0EE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_43660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39.834,
    fill: "white",
    transform: "translate(0.775879 0.0839844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryNegative);
export default __webpack_public_path__ + "static/media/Very-Negative.84b372f2b8cc56d39c994107f5a926bb.svg";
export { ForwardRef as ReactComponent };